import React, { useState } from 'react';
import { BuildingIcon, MapPinIcon, PhoneIcon, MailIcon, UserIcon, TruckIcon } from 'lucide-react';
export function CustomerInfoStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    dealerName: initialData.dealerName || '',
    dealerContact: initialData.dealerContact || '',
    dealerEmail: initialData.dealerEmail || '',
    dealerPhone: initialData.dealerPhone || '',
    billToCompany: initialData.billToCompany || '',
    billToAddress: initialData.billToAddress || '',
    billToCountry: initialData.billToCountry || '',
    shipToCompany: initialData.shipToCompany || '',
    shipToAddress: initialData.shipToAddress || '',
    shipToCountry: initialData.shipToCountry || '',
    consigneeName: initialData.consigneeName || '',
    consigneeContact: initialData.consigneeContact || '',
    consigneeEmail: initialData.consigneeEmail || '',
    consigneePhone: initialData.consigneePhone || '',
    notifyName: initialData.notifyName || '',
    notifyContact: initialData.notifyContact || '',
    notifyEmail: initialData.notifyEmail || '',
    notifyPhone: initialData.notifyPhone || '',
    ...initialData
  });
  const [sameAsBillTo, setSameAsBillTo] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSameAsBillToChange = e => {
    const checked = e.target.checked;
    setSameAsBillTo(checked);
    if (checked) {
      setFormData({
        ...formData,
        shipToCompany: formData.billToCompany,
        shipToAddress: formData.billToAddress,
        shipToCountry: formData.billToCountry
      });
    }
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-8" data-id="element-4778">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4779">
        Customer Information
      </div>
      {/* Dealer Information */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4780">
        <div className="flex items-center mb-4" data-id="element-4781">
          <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4782" />
          <h3 className="text-white font-medium" data-id="element-4783">Dealer Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4784">
          <div data-id="element-4785">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4786">
              Dealer Name
            </label>
            <input type="text" name="dealerName" value={formData.dealerName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter dealer name" data-id="element-4787" />
          </div>
          <div data-id="element-4788">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4789">
              Contact Person
            </label>
            <input type="text" name="dealerContact" value={formData.dealerContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4790" />
          </div>
          <div data-id="element-4791">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4792">Email</label>
            <input type="email" name="dealerEmail" value={formData.dealerEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address" data-id="element-4793" />
          </div>
          <div data-id="element-4794">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4795">Phone</label>
            <input type="text" name="dealerPhone" value={formData.dealerPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone number" data-id="element-4796" />
          </div>
        </div>
      </div>
      {/* Billing and Shipping Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4797">
        {/* Bill To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4798">
          <div className="flex items-center mb-4" data-id="element-4799">
            <MapPinIcon size={20} className="text-blue-400 mr-2" data-id="element-4800" />
            <h3 className="text-white font-medium" data-id="element-4801">Bill To</h3>
          </div>
          <div className="space-y-4" data-id="element-4802">
            <div data-id="element-4803">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4804">
                Company Name
              </label>
              <input type="text" name="billToCompany" value={formData.billToCompany} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter company name" data-id="element-4805" />
            </div>
            <div data-id="element-4806">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4807">
                Address
              </label>
              <textarea name="billToAddress" value={formData.billToAddress} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter complete address" data-id="element-4808"></textarea>
            </div>
            <div data-id="element-4809">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4810">
                Country
              </label>
              <input type="text" name="billToCountry" value={formData.billToCountry} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter country" data-id="element-4811" />
            </div>
          </div>
        </div>
        {/* Ship To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4812">
          <div className="flex items-center justify-between mb-4" data-id="element-4813">
            <div className="flex items-center" data-id="element-4814">
              <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-4815" />
              <h3 className="text-white font-medium" data-id="element-4816">Ship To</h3>
            </div>
            <div className="flex items-center" data-id="element-4817">
              <input type="checkbox" id="sameAsBillTo" checked={sameAsBillTo} onChange={handleSameAsBillToChange} className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-4818" />
              <label htmlFor="sameAsBillTo" className="text-sm text-blue-300" data-id="element-4819">
                Same as Bill To
              </label>
            </div>
          </div>
          <div className="space-y-4" data-id="element-4820">
            <div data-id="element-4821">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4822">
                Company Name
              </label>
              <input type="text" name="shipToCompany" value={formData.shipToCompany} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter company name" data-id="element-4823" />
            </div>
            <div data-id="element-4824">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4825">
                Address
              </label>
              <textarea name="shipToAddress" value={formData.shipToAddress} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter complete address" data-id="element-4826"></textarea>
            </div>
            <div data-id="element-4827">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4828">
                Country
              </label>
              <input type="text" name="shipToCountry" value={formData.shipToCountry} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter country" data-id="element-4829" />
            </div>
          </div>
        </div>
      </div>
      {/* Consignee and Notify Party */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4830">
        {/* Consignee */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4831">
          <div className="flex items-center mb-4" data-id="element-4832">
            <UserIcon size={20} className="text-blue-400 mr-2" data-id="element-4833" />
            <h3 className="text-white font-medium" data-id="element-4834">Consignee</h3>
          </div>
          <div className="space-y-4" data-id="element-4835">
            <div data-id="element-4836">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4837">Name</label>
              <input type="text" name="consigneeName" value={formData.consigneeName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter consignee name" data-id="element-4838" />
            </div>
            <div data-id="element-4839">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4840">
                Contact Person
              </label>
              <input type="text" name="consigneeContact" value={formData.consigneeContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4841" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4842">
              <div data-id="element-4843">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4844">
                  Email
                </label>
                <input type="email" name="consigneeEmail" value={formData.consigneeEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4845" />
              </div>
              <div data-id="element-4846">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4847">
                  Phone
                </label>
                <input type="text" name="consigneePhone" value={formData.consigneePhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4848" />
              </div>
            </div>
          </div>
        </div>
        {/* Notify Party */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4849">
          <div className="flex items-center mb-4" data-id="element-4850">
            <PhoneIcon size={20} className="text-blue-400 mr-2" data-id="element-4851" />
            <h3 className="text-white font-medium" data-id="element-4852">Notify Party</h3>
          </div>
          <div className="space-y-4" data-id="element-4853">
            <div data-id="element-4854">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4855">Name</label>
              <input type="text" name="notifyName" value={formData.notifyName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter notify party name" data-id="element-4856" />
            </div>
            <div data-id="element-4857">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4858">
                Contact Person
              </label>
              <input type="text" name="notifyContact" value={formData.notifyContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4859" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4860">
              <div data-id="element-4861">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4862">
                  Email
                </label>
                <input type="email" name="notifyEmail" value={formData.notifyEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4863" />
              </div>
              <div data-id="element-4864">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4865">
                  Phone
                </label>
                <input type="text" name="notifyPhone" value={formData.notifyPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4866" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}